var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "slideInRight", delay: 0, duration: 500 },
          expression: "{ classes: 'slideInRight', delay: 0, duration: 500 }",
        },
      ],
      staticClass: "block-modal",
      attrs: { "block-type": _vm.block.type },
    },
    [
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "left" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center align-content-center justify-content-start pb-2",
              },
              [
                _c("BlockIconPreview", {
                  staticClass: "mr-2",
                  staticStyle: { color: "#919ead" },
                  attrs: { "block-type": _vm.block.type },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "blockTypeText" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2." + _vm.block.type))),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "name" },
              [
                _c("BlockTitle", {
                  attrs: {
                    name: _vm.block.name,
                    storyId: _vm.storyId,
                    block: _vm.block,
                    storyVersion: _vm.storyVersion,
                    "is-save": _vm.isSaveProp,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            _c(
              "button",
              {
                staticClass: "chatbot-btn",
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [
                _c("md-icon", { staticStyle: { color: "red" } }, [
                  _vm._v("close"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.previewMode
              ? _c(
                  "button",
                  {
                    staticClass: "chatbot-btn",
                    on: {
                      click: function ($event) {
                        return _vm.updatePayload()
                      },
                    },
                  },
                  [
                    _c("md-icon", { staticStyle: { color: "green" } }, [
                      _vm._v("save"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.block.type.includes("PROBEL") &&
            !_vm.block.type.includes("IDEASOFT") &&
            !_vm.block.type.includes("B2CARGO") &&
            !_vm.block.type.includes("HOLIDAY_PLUS") &&
            !_vm.block.type.includes("ZOHO")
              ? _c(
                  "button",
                  {
                    staticClass: "chatbot-btn",
                    on: {
                      click: function ($event) {
                        _vm.showBlockInfo = true
                      },
                    },
                  },
                  [
                    _c("md-icon", { staticStyle: { color: "dodgerblue" } }, [
                      _vm._v("info"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showBlockInfo
              ? _c(
                  "div",
                  {
                    staticClass: "custom-modal-overlay",
                    on: {
                      click: function ($event) {
                        if ($event.target !== $event.currentTarget) {
                          return null
                        }
                        _vm.showBlockInfo = false
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "custom-modal" }, [
                      _c("div", { staticClass: "custom-modal-header" }, [
                        _c("h3", { staticStyle: { "font-weight": "700" } }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2." + _vm.block.type))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "close-btn",
                            on: {
                              click: function ($event) {
                                _vm.showBlockInfo = false
                              },
                            },
                          },
                          [_c("md-icon", [_vm._v("close")])],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "custom-modal-content" }, [
                        _c("div", { staticClass: "platform-info" }, [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "1.2rem",
                                color: "initial",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$t(
                                      "chatbotv2." + _vm.block.type + "Desc"
                                    )
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "custom-modal-footer" },
                        [
                          _c(
                            "SupsisButton",
                            {
                              staticClass: "documentation-link",
                              attrs: { ghost: "" },
                              on: { click: _vm.openDocumentation },
                            },
                            [
                              _c(
                                "i",
                                {
                                  staticClass: "material-icons",
                                  staticStyle: { padding: "0px 0px 0px 5px" },
                                },
                                [_vm._v("open_in_new")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: { padding: "0px 15px 0px 5px" },
                                },
                                [_vm._v(_vm._s(_vm.$t("billing.more")))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "SupsisButton",
                            {
                              attrs: { primary: "" },
                              on: {
                                click: function ($event) {
                                  _vm.showBlockInfo = false
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { padding: "0px 10px" } },
                                [_vm._v(_vm._s(_vm.$t("message.close")))]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body" }, [
          _vm.previewMode
            ? _c(
                "span",
                { staticClass: "bg-primary text-light p-3 w-100 d-block" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("chatbotv2.previewModeCaution")) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.payload
            ? _c("div", { staticClass: "payload-wrapper" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("chatbotv2.addPayload")) +
                    "\n            "
                ),
              ])
            : _c(
                "div",
                { staticClass: "payload-wrapper" },
                [
                  _vm.block.type === _vm.BLOCK_TYPES.BOT_RESPONSE
                    ? [
                        _c("BotResponse", {
                          attrs: {
                            "preview-mode": _vm.previewMode,
                            flattedDiagram: _vm.flattedDiagram,
                          },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.BLOCK_TYPES.AI_BOT_RESPONSE
                    ? [
                        _c("AIBotResponse", {
                          attrs: {
                            "preview-mode": _vm.previewMode,
                            flattedDiagram: _vm.flattedDiagram,
                          },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.BLOCK_TYPES.AI_CLASSIFICATION
                    ? [
                        _c("AIClassification", {
                          attrs: {
                            "preview-mode": _vm.previewMode,
                            flattedDiagram: _vm.flattedDiagram,
                          },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.USER_INPUT
                    ? [
                        _c("UserInput", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.ATTACHMENT_INPUT
                    ? [
                        _c("AttachmentInput", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.GO_TO_STEP
                    ? [
                        _c("GotoStep", {
                          attrs: {
                            "flatted-diagram": _vm.flattedDiagram,
                            isGotoStep:
                              _vm.block.type === _vm.BLOCK_TYPES.GO_TO_STEP,
                          },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.ADD_TO_SEGMENT
                    ? [
                        _c("AddToSegment", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.REMOVE_FROM_SEGMENT
                    ? [
                        _c("RemoveFromSegment", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TRANSFER_TO_CHATBOT
                    ? [
                        _c("ForwardToChatbot", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.SET_ATTRIBUTE
                    ? [
                        _c("SetAttribute", {
                          attrs: { payloads: _vm.Payloads },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.SET_DEPARTMENT
                    ? [
                        _c("SetDepartment", {
                          attrs: { payloads: _vm.Payloads },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.QUESTION
                    ? [
                        _c("Question", {
                          attrs: { payloads: _vm.Payloads },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.FILTER
                    ? [
                        _c("FilterBlockEditor", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.AKINON_ORDER_STATUS
                    ? [
                        _c("AkinonOrderStatus", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.AKINON_SELECT_ORDER
                    ? [
                        _c("AkinonSelectOrder", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.AKINON_SELECT_SIZE
                    ? [
                        _c("AkinonSelectSize", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type ===
                      _vm.BLOCK_TYPES.AKINON_FIND_NEAREST_STOCK
                    ? [
                        _c("AkinonFindNearestStock", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type ===
                      _vm.BLOCK_TYPES.AKINON_FIND_NEAREST_STORES
                    ? [
                        _c("AkinonFindNearestStores", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.AKINON_FIND_PRODUCT
                    ? [
                        _c("AkinonFindProduct", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type ===
                      _vm.BLOCK_TYPES.AKINON_SHOW_DISCOUNT_CODES
                    ? [
                        _c("AkinonShowDiscountCodes", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.SEND_TRANSCRIPT
                    ? [
                        _c("SendTranscript", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.SEND_SMS
                    ? [
                        _c("SendSMS", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.SEND_MAIL
                    ? [
                        _c("SendMail", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.CREATE_EVENT
                    ? [
                        _c("CreateEvent", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.CREATE_RESERVATION
                    ? [
                        _c("CreateReservation", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.RESERVATION_OPEN_URL
                    ? [
                        _c("ReservationOpenUrl", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.RESERVATION_SELECT_DAY
                    ? [
                        _c("ReservationSelectDay", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.RESERVATION_SELECT_TIME
                    ? [
                        _c("ReservationSelectTime", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.RESERVATION_EVENT_LIST
                    ? [
                        _c("ReservationEventList", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.CREATE_TICKET
                    ? [
                        _c("CreateTicket", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TAG_CHAT
                    ? [
                        _c("AddTag", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.REMOVE_TAG
                    ? [
                        _c("RemoveTag", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.WEBHOOK
                    ? [
                        _c("WebHook", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.GET_LOCATION
                    ? [
                        _c("GetLocation", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.PROBEL_SELECT_BRANCH
                    ? [
                        _c("ProbelSelectBranch", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.PROBEL_SELECT_CLINIC
                    ? [
                        _c("ProbelSelectPolyClinic", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.PROBEL_SELECT_DAY
                    ? [
                        _c("ProbelSelectDay", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.PROBEL_SELECT_HOUR
                    ? [
                        _c("ProbelSelectHour", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.PROBEL_MAKE_APPOINTMENT
                    ? [
                        _c("ProbelMakeAppointment", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type ===
                      _vm.BLOCK_TYPES.PROBEL_CANCEL_APPOINTMENT
                    ? [
                        _c("ProbelCancelAppointment", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type ===
                      _vm.BLOCK_TYPES.PROBEL_GET_PATIENT_TOKEN
                    ? [
                        _c("ProbelGetPatientToken", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.PROBEL_FILL_INFO
                    ? [
                        _c("ProbelFillInfo", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type ===
                      _vm.BLOCK_TYPES.PROBEL_SELECT_APPOINTMENT
                    ? [
                        _c("ProbelSelectAppointment", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.CREATE_TASK
                    ? [
                        _c("CreateTask", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.IDEASOFT_SELECT_ORDER
                    ? [
                        _c("IdeasoftSelectOrder", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.IDEASOFT_ORDER_STATUS
                    ? [
                        _c("IdeasoftOrderStatus", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type ===
                      _vm.BLOCK_TYPES.IDEASOFT_GET_MEMBER_INFO
                    ? [
                        _c("IdeasoftGetMemberInfo", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.IDEASOFT_PRODUCT_SEARCH
                    ? [
                        _c("IdeasoftProductSearch", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.SUPPRESSION_ADD
                    ? [
                        _c("SuppressionAdd", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.SUPPRESSION_REMOVE
                    ? [
                        _c("SuppressionRemove", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.B2CARGO_LOGIN_USER
                    ? [
                        _c("B2CargoLoginUser", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.B2CARGO_PRODUCT_STATUS
                    ? [
                        _c("B2CargoProductStatus", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.DEFAULT_TIMEOUT
                    ? [
                        _c("TimeoutBlock", {
                          attrs: { global: true },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TIMEOUT
                    ? [
                        _c("TimeoutBlock", {
                          attrs: { flattedDiagram: _vm.flattedDiagram },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type ===
                      _vm.BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE
                    ? [
                        _c("WhatsappBusinessMessage", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type ===
                      _vm.BLOCK_TYPES.INSTAGRAM_COMMENT_REPLY_AS_PRIVATE
                    ? [
                        _c("InstagramCommentReplyAsPrivate", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.INSTAGRAM_COMMENT_HIDE
                    ? [
                        _c("InstagramCommentHide", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.INSTAGRAM_COMMENT_SHOW
                    ? [
                        _c("InstagramCommentShow", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type ===
                      _vm.BLOCK_TYPES.INSTAGRAM_COMMENT_DELETE
                    ? [
                        _c("InstagramCommentDelete", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.INSTAGRAM_COMMENT_REPLY
                    ? [
                        _c("InstagramCommentReply", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.HOLIDAY_PLUS_GET_HOTELS
                    ? [
                        _c("HolidayPlusHotels", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.HOLIDAY_PLUS_GET_ROOMS
                    ? [
                        _c("HolidayPlusRooms", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TABLE_CREATE_RECORD
                    ? [
                        _c("CreateRecord", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TABLE_UPDATE_RECORD
                    ? [
                        _c("UpdateRecord", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TABLE_DELETE_RECORD
                    ? [
                        _c("DeleteRecord", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TABLE_FIND_RECORD
                    ? [
                        _c("FindRecord", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TABLE_FIND_RECORDS
                    ? [
                        _c("FindRecords", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.ZOHO_CREATE_RECORD
                    ? [
                        _c("ZohoCreateRecord", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.API_REQUEST
                    ? [
                        _c("CustomWebhook", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.FEEDBACK_AI_ASSISTANT
                    ? [
                        _c("FeedbackAIAssistant", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.ASSIGN_OWNER
                    ? [
                        _c("AssignOwner", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.INSTAGRAM_SEND_MESSAGE
                    ? [
                        _c("InstagramSendMessage", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.MESSENGER_SEND_MESSAGE
                    ? [
                        _c("MessengerSendMessage", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TAVILY_WEB_SEARCH
                    ? [
                        _c("TavilyWebSearch", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.OPENAI_WEB_SEARCH
                    ? [
                        _c("OpenaiWebSearch", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TSOFT_ORDER_STATUS
                    ? [
                        _c("TsoftOrderStatus", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TSOFT_SELECT_ORDER
                    ? [
                        _c("TsoftSelectOrder", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TICIMAX_V2_ORDER_STATUS
                    ? [
                        _c("TicimaxV2OrderStatus", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.TICIMAX_V2_SELECT_ORDER
                    ? [
                        _c("TicimaxV2SelectOrder", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.BLOCK_TYPES.AI_CALL
                    ? [
                        _c("AICall", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.BLOCK_TYPES.IKAS_GET_MEMBER_INFO
                    ? [
                        _c("IkasGetMemberInfo", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.IKAS_SELECT_ORDER
                    ? [
                        _c("IkasSelectOrder", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.IKAS_ORDER_STATUS
                    ? [
                        _c("IkasOrderStatus", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.INSERT_TO_SYSTEM_PROMPT
                    ? [
                        _c("InsertToSystemPrompt", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.META_SEND_CAPI_EVENT
                    ? [
                        _c("MetaSendCapiEvent", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.RUN_JAVASCRIPT
                    ? [
                        _c("RunJavaScript", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm.block.type === _vm.BLOCK_TYPES.CUSTOM_BLOCK
                    ? [
                        _c("CustomBlockConfig", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }